<template>
  <div v-cloak>

    <div class="acea-row row-between-wrapper imgView">
          <img src="first.png" class="imageStyle" />
    </div>

    <div class="viewGo acea-row row-between-wrapper">
          点击【继续】说明你已同意本平台相关使用协议。
    </div>

    <router-link
          :to="{ path: '/protocol' }"
        >
        <div class="btnViewXieyi">
            点此查看详细[立数教育校园收费通管理平台软件使用协议]
        </div>
    </router-link>

    <div class="header btnView acea-row row-center-wrapper" @click="goHome" type="submit">继              续</div>
  </div>
</template>
<style>
.inputView {
  height: 20px;
  margin: 10px;
  font-size: 16px;
}
.labelText {
  font-size: 14px;
  color: #000000;
  background-color: #fff;
}
.labelText2 {
  font-size: 14px;
  color: red;
  background-color: #fff;
}
.detailView {
  margin: 10px;
  color: #000000;
  font-size: 10px;
  display: flex;
  justify-content: center;
  border-radius:10px;
}
.viewGo{
  margin-top: 10%; 
  color: black;
  font-size: 14px;
  width: 90%;
  margin-left: 10%;
  /* display: flex;
  justify-content: center; */
}
.btnViewXieyi {
  margin-top: 10px; 
  color: black;
  font-size: 10px;
  width: 90%;
  margin-left: 10%;
}

.btnView {
  margin-top: 40px; 
  height: 40px;
  background-color:#2EBCBF;
  color: #fff;
  font-size: 20px;
  display: flex;
  justify-content: center;
  width: 80%;
  margin-left: 10%;
  border-radius: 10px;
}
.syTitle {
  margin-top: 10px;
  /* background-color: #e93323; */
  color: #000000;
  font-size: 20px;
}

.syDetail {
  font-size: 14px;
}
.mask {
  -webkit-filter: blur(2px);
  -moz-filter: blur(2px);
  -ms-filter: blur(2px);
  filter: blur(2px);
}
.footer .icon-shoucang1 {
  color: #e93323;
}
.product-con .product-intro .conter div {
  width: 100% !important;
}
.generate-posters {
  width: 100%;
  height: 1.7rem;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  transform: translate3d(0, 100%, 0);
  -webkit-transform: translate3d(0, 100%, 0);
  -ms-transform: translate3d(0, 100%, 0);
  -moz-transform: translate3d(0, 100%, 0);
  -o-transform: translate3d(0, 100%, 0);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
.generate-posters.on {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
}
.generate-posters .item {
  flex: 50%;
  -webkit-flex: 50%;
  -ms-flex: 50%;
  text-align: center;
}
.generate-posters .item .iconfont {
  font-size: 0.8rem;
  color: #5eae72;
}
.generate-posters .item .iconfont.icon-haibao {
  color: #5391f1;
}
.imageStyle {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.imgView{
  margin-top: 10%;
}
</style>
<script>


import {
  getOrderInfo,
  getProductDetail,
  getOpenId,
  getSchoolList,
  getGradeList,
  getClassesList
} from "@api/public";


import { isWeixin } from "@utils/index";
import { mapGetters } from "vuex";
import { log } from 'util';
import { Toast } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { pay , oAuth, wechat} from "@libs/wechat";
import { parseQuery } from "@utils/index";
import cookie from "@utils/store/cookie";

import { Loading } from 'vant';
import { Field } from 'vant';
import { Button, Popup, Picker } from 'vant';
import {  Row, Col  } from 'vant';

import { wechatConfigBuy} from "@libs/wechat";

export default {
  name: "GoodsCon",
  components: {
    [Loading.name]:Loading,
    [Field.name]:Field,
    [Button.name]:Button,
    [Popup.name]:Popup,
    [Picker.name]:Picker,
    Toast,
    [Row.name]:Row,
    [Col.name]:Col
  },
  data: function() {
    return {
      paySuccess: 0,
      showPickerSchool: false,
      showPickerClass: false,
      showPickerSubClass: false,

      schoolColumns: [],
      gradeColumns: [],
      classesColumns: [],

      schoolIdList: [],
      gradeIdList: [],
      classesIdList: [],

      checked: true,
      title: "",
      price: "",
      detail: "",
      grade: "",
      gradeId: "",
      classes: "",
      classesId: "",
      phone: "",
      school: "",
      schoolId: "",
      userName: "",
      tradeImageList:[]
    };
  },
  computed: mapGetters(["isLogin"]),
  mounted: function() {


  },
  methods: {
    stop(){
      let that = this;
				clearInterval(that.interval);
				that.interval = null;
      },
    start(){//启动计时器函数
        let that = this;
				if(that.interval!=null){//判断计时器是否为空
					clearInterval(that.interval);
					that.interval=null;
				}
				that.interval = setInterval(that.overs,1500);//启动计时器，调用overs函数，
      },
    overs(){
        let that = this;
        //log("--------time out---------", that.paySuccess);
        if (that.paySuccess == 1){
          stop();
          window.location.href = "http://datum.lishuedu.com/about";
        }
			},
    onConfirmSchool(value) {
      this.school = value;
      this.showPickerSchool = false;
      for (let index = 0; index < this.schoolColumns.length; index++) {
        const element = this.schoolColumns[index];
        if (element == this.school) {
          this.schoolId = this.schoolIdList[index];
          break;
        }
        
      }

      this.getGradeListMem();
    },
    onConfirmGrade(value) {
      this.grade = value;
      this.showPickerClass = false;

       for (let index = 0; index < this.gradeColumns.length; index++) {
        const element = this.gradeColumns[index];
        if (element == this.grade) {
          this.gradeId = this.gradeIdList[index];
          break;
        }
        
      }

      this.getClassesListMem();
    },
    onConfirmClass(value) {
      this.classes = value;
      this.showPickerSubClass = false;

      for (let index = 0; index < this.classesColumns.length; index++) {
        const element = this.classesColumns[index];
        if (element == this.classes) {
          this.classesId = this.classesIdList[index];
          break;
        }
        
      }
    },
    //产品详情接口；
    goHome: function() {
      window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx3d4cd5590cd19363&redirect_uri=http://datum.lishuedu.com/&response_type=code&scope=snsapi_base&state=1#wechat_redirect";
    },

    
  }
};
</script>
